// ─────────────────────────────────────────────────────────────
// DESIGN TOKENS
// ─────────────────────────────────────────────────────────────

export const F = {
  display: 'var(--brand-display-font, Georgia, serif)',
  body:    '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
  mono:    '"JetBrains Mono", "Courier New", monospace',
};

export const C = {
  white: '#ffffff',
  fa:    '#fafafa',
  f4:    '#f4f4f4',
  e8:    '#e8e8e8',
  d0:    '#d0d0d0',
  text:  '#0a0a0a',
  text2: '#3a3a3a',
  muted: '#777777',
  ph:    '#aaaaaa',
  brand: 'var(--brand-accent, #0a0a0a)',
};

export const STATUS_STYLE = {
  empty:    { fg: '#999999', bg: '#f5f5f5', border: '#e5e5e5', label: 'Not started' },
  progress: { fg: '#555555', bg: '#f0f0f0', border: '#d5d5d5', label: 'In progress' },
  review:   { fg: '#92400e', bg: '#fef3c7', border: '#fcd34d', label: 'Needs review' },
  approved: { fg: '#065f46', bg: '#d1fae5', border: '#6ee7b7', label: 'Approved' },
};

// ─────────────────────────────────────────────────────────────
// STYLE HELPERS
// ─────────────────────────────────────────────────────────────

export const btn = (variant = 'primary', extra = {}) => {
  const base = {
    fontFamily: F.body, fontSize: 13, fontWeight: 500, cursor: 'pointer',
    border: 'none', borderRadius: 6, padding: '8px 14px',
    display: 'inline-flex', alignItems: 'center', gap: 6,
    transition: 'opacity 0.15s', whiteSpace: 'nowrap',
    ...extra,
  };
  if (variant === 'primary')   return { ...base, background: 'var(--brand-primary, #0a0a0a)', color: 'var(--brand-primary-fg, #ffffff)' };
  if (variant === 'secondary') return { ...base, background: C.f4,          color: C.text, border: `1px solid ${C.e8}` };
  if (variant === 'ghost')     return { ...base, background: 'transparent', color: C.text };
  if (variant === 'danger')    return { ...base, background: '#fef2f2',     color: '#dc2626', border: '1px solid #fecaca' };
  if (variant === 'success')   return { ...base, background: '#d1fae5',     color: '#065f46', border: '1px solid #6ee7b7' };
  return base;
};

export const inp = (extra = {}) => ({
  fontFamily: F.body, fontSize: 13, color: C.text,
  border: `1px solid ${C.e8}`, borderRadius: 6,
  padding: '8px 10px', background: C.white, width: '100%',
  outline: 'none', boxSizing: 'border-box',
  ...extra,
});

export const lbl = (extra = {}) => ({
  fontFamily: F.body, fontSize: 12, fontWeight: 500,
  color: C.muted, display: 'block', marginBottom: 4,
  ...extra,
});
